module.exports = __webpack_public_path__ + "img/T5-D-rc_6.a00de977.png";